import type { BlocksGalleryItemComponent } from '@twisto/api-cms'

import { Button, StrapiMedia } from '../../atoms'

import * as styles from './gallery.styles'

export const GalleryItem = ({
  title,
  subtitle,
  image,
  cta,
}: BlocksGalleryItemComponent) => (
  <div css={[styles.item, cta && styles.hover]}>
    <StrapiMedia {...image} />
    <div className="gallery-item-content" css={styles.content}>
      <p css={styles.itemSubtitle}>{subtitle}</p>
      <h3 css={styles.itemTitle}>{title}</h3>
      {cta?.text && cta.link && (
        <Button text={cta.text} url={cta.link} variant="inverted" />
      )}
    </div>
  </div>
)
